/**
 * Enum representing different size options for UI components, like buttons or links.
 */
export var Size;
(function (Size) {
    Size["None"] = "";
    Size["Large"] = "lg";
    Size["Medium"] = "md";
    Size["Small"] = "sm";
})(Size || (Size = {}));
//# sourceMappingURL=Size.js.map